<template>
    <propertyPop ref="pop" type="pop3d" v-ga:pop="{pageType: 'vdpp3d', glb: glb, state: dpp}" @hide="excuted">
        <template v-slot:header>
        </template>
        <template v-slot:body="dpp">
            <div  class="property-pop-3d" v-if="url">
                <iframe id="virtualtouriframe" v-show="loaded"  :src="url" @load="onload" allow='autoplay'></iframe>
                <div class="flex center middle loading" v-if="!loaded">
                   <img src="/css/desktop/img/loading-data.gif" loading="lazy" alt="loading tour">
                </div>
            </div>
        </template>
    </propertyPop>
</template>
<script src="./property-pop3d.js"></script>

<style lang="scss">
@use "./property-pop3d.scss" as *;
</style>
